import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";
import { AuthProvider } from "./contexts/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import PublicLayout from "./components/PublicLayout";

import Home from "./pages/Home";
import HowItWorks from "./pages/HowItWorks";
import Appointment from "./pages/Appointment";
import Partners from "./pages/Partners";
import Centers from "./pages/Centers";
import CenterDetail from "./pages/CenterDetail";
import FAQ from "./pages/FAQ";
import Blog from "./pages/Blog";
import BlogPost from "./pages/BlogPost";
import Contact from "./pages/Contact";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Legal from "./pages/Legal";
import RGPDRequest from "./pages/RGPDRequest";

import ClientDashboard from "./pages/dashboard/ClientDashboard";
import CenterDashboard from "./pages/dashboard/CenterDashboard";
import AdminDashboard from "./pages/dashboard/AdminDashboard";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Toaster richColors position="top-center" />
          <Routes>
            <Route element={<PublicLayout />}>
              <Route path="/" element={<Home />} />
              <Route path="/comment-ca-marche" element={<HowItWorks />} />
              <Route path="/prendre-rendez-vous" element={<Appointment />} />
              <Route path="/partenaires" element={<Partners />} />
              <Route path="/centres" element={<Centers />} />
              <Route path="/centres/:id" element={<CenterDetail />} />
              <Route path="/faq" element={<FAQ />} />
              <Route path="/blog" element={<Blog />} />
              <Route path="/blog/:slug" element={<BlogPost />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/connexion" element={<Login />} />
              <Route path="/inscription" element={<Register />} />
              <Route path="/mentions-legales" element={<Legal page="mentions" />} />
              <Route path="/cgu" element={<Legal page="cgu" />} />
              <Route path="/confidentialite" element={<Legal page="privacy" />} />
              <Route path="/cookies" element={<Legal page="cookies" />} />
              <Route path="/exercer-mes-droits" element={<RGPDRequest />} />
            </Route>

            <Route
              path="/espace-client/*"
              element={
                <ProtectedRoute roles={["client"]}>
                  <ClientDashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/espace-centre/*"
              element={
                <ProtectedRoute roles={["center"]}>
                  <CenterDashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/administration/*"
              element={
                <ProtectedRoute roles={["admin", "superadmin"]}>
                  <AdminDashboard />
                </ProtectedRoute>
              }
            />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
